import { useTranslation } from 'react-i18next';

import useModals from 'modals/hooks';
import { FeedbackModalTemplate } from 'modals/Templates';

import { CustomPrimaryButton } from 'components/Buttons';

import { SuccessModalPropsType } from './types';

const dataLocators = {
    body: 'successfulBlock',
};

const SuccessModal = ({
    image,
    title,
    subtitle,
    buttonText,
    withCloseButton,
    withRoundedCorners,
}: SuccessModalPropsType) => {
    const { closeModal } = useModals();

    const { t } = useTranslation();

    return (
        <FeedbackModalTemplate
            dataLocators={dataLocators}
            image={image}
            title={title}
            subtitle={subtitle}
            withCloseButton={withCloseButton}
            withRoundedCorners={withRoundedCorners}
            marginTop={24}
            imageWidth={28}
        >
            <CustomPrimaryButton dataLocator="successContinueButton" onClick={closeModal}>
                {t(buttonText)}
            </CustomPrimaryButton>
        </FeedbackModalTemplate>
    );
};

export default SuccessModal;
